document.addEventListener('variant:change', function(evt) {
  const variant = evt.detail.variant;

  const variantInventoryObject = window.inventories[evt.detail.productID][variant.id];
  const { quantity, policy, incoming, next_incoming_date } = variantInventoryObject || {};

  // if (quantity <= 0) {
  //   document.querySelector('.custom-product_availability').classList.add("hide");
  // } else {
  //   document.querySelector('.custom-product_availability').classList.remove("hide");
  //   document.querySelector('.custom-product_availability').textContent = `Availablity: in stock. (${quantity} items left)`
  // }

 
  if(quantity <= 0) {
    if(document.querySelector("[data-inventory-info]")) {
      document.querySelector("[data-inventory-info]").textContent = "on order 12–16 weeks.";
    }
    document.querySelector('[data-add-to-cart-text]').textContent = "Pre - Order";
  } else {
    if(document.querySelector("[data-inventory-info]")) {
      document.querySelector("[data-inventory-info]").textContent = "in stock.";
    }
    document.querySelector('[data-add-to-cart-text]').textContent = "Add to cart";
  }
  
  if(document.querySelector("[id^='VariantMetafields-']")) {
    const metafieldsData = JSON.parse(document.querySelector("[id^='VariantMetafields-']").textContent.trim());
    if(variant && metafieldsData) {
      selectedVariant = metafieldsData.find(variantMetafields => variantMetafields.id === variant.id)
      if(selectedVariant && document.querySelector("[id^='variant-featured-text-']")) {
        document.querySelector("[id^='variant-featured-text-']").textContent = selectedVariant.featured_text;
      }
    }
  }
});